<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :request-params="requestParams"
            :repository="repositories.paciente"
            :disabled-button-search="true"
            ref="DataTable"
            search-by="nome"
        >
            <template v-slot:cell(dataNascimento)="row">
                {{ row.value | formatDate }}
            </template>

            <template v-slot:cell(cpf)="row">
                {{ row.value | formatCpf }}
            </template>

            <template v-slot:cell(cns)="row">
                {{ row.value | formatCns }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="open(item)"
                    color="primary"
                    small
                    title="Gerenciar processos"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalProcesso ref="ModalProcesso" />
    </div>
</template>

<script>
// Components.
import ModalProcesso from './components/processo/Modal'

// Others.
import { repository, error } from '@/mixins'
import formats from '@/filters/formats'

export default {
    components: { ModalProcesso },
    computed: {
        requestParams() {

            return { with_prontuario_unidade: true }
        },
        fields() {

            return [
                {
                    key: 'prontuario',
                    name: 'cadastro_paciente.prontuario',
                    label: 'Prontuário',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'prontuarioUnidade',
                    name: 'cadastro_prontuario_unidade.prontuario',
                    label: 'Prontuário da unidade',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'nome',
                    name: 'cadastro_cidadao.nome',
                    label: 'Nome',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'nomeMae',
                    name: 'cadastro_cidadao.nome_mae',
                    label: 'Nome da mãe',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dataNascimento',
                    name: 'cadastro_cidadao.data_nascimento',
                    label: 'Data de nascimento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cns',
                    name: 'cadastro_cidadao.cns',
                    label: 'CNS',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cpf',
                    name: 'cadastro_cidadao.cpf',
                    label: 'CPF',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')
        }
    },
    methods: {
        open(item) {

            if (item.diasCadastroDesatualizado > 0) {

                const confirm = async () => {

                    this.$refs.ModalProcesso.open(item)

                    return false
                }

                const msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                    dia(s). Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            }

            this.$refs.ModalProcesso.open(item)
        }
    },
    filters: {
        ...formats
    },
    mixins: [repository, error]
}
</script>